import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Icon, MenuItem, MenuList } from '@material-ui/core';
import { Url } from '../../../common/constants';
import { IsEmpty } from '../../../common/checks';
import Util from '../../../common/util';
import apiService from '../../../services.js/apiService';
import { editPage } from '../../../actions/admin/pageAction';
import PageHighlightRouter from './router';

const PageHighlight = ({ match, location, pageInView, dispatchEditPage }) => {
  const [pageId, setPageId] = useState(null);
  const [pageHighlightId, setPageHighlightId] = useState(null);
  const [isSpecial, setIsSpecial] = useState(false);
  const [isExclusive, setIsExclusive] = useState(false);

  useEffect(() => {
    const query = Util.ExtractParamsFromUrlQueryStr(location.search);
    if (!IsEmpty(query)) {
      setIsSpecial(query.isSpecial === 'true' || false);
      setIsExclusive(query.isExclusive === 'true' || false);
    }

    setPageId(match.params.pageId || null);
    setPageHighlightId(match.params.pageHighlightId);
  }, []);

  useEffect(() => {
    const getPageData = async () => {
      const p = await apiService.getPageById(pageId);
      dispatchEditPage(p);
    };

    if (!IsEmpty(pageId)) {
      getPageData();
    }
  }, [pageId]);

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="d-flex justify-content-start content-header">
            <h1 className="d-flex align-items-center">
              <Link to={`${Url.PageHighlights.replace(':pageId', pageId)}${isSpecial ? '?isSpecial=true' : isExclusive ? '?isExclusive=true' : ''}`} title="Back" className="d-flex align-items-center">
                <Icon className="back">arrow_back</Icon>
              </Link>
              {pageInView ? pageInView.name : ''}
              {` / highlight / ${pageHighlightId}`}
            </h1>

          </div>
          <div className="row">
            <div className="col-md-2" style={{ backgroundColor: '#fff' }}>
              <MenuList>
                <Link to={`${match.url}${isSpecial ? '?isSpecial=true' : isExclusive ? '?isExclusive=true' : ''}`}><span><MenuItem>Info</MenuItem></span></Link>
                {
                  isSpecial
                    ? <Link to={`${match.url}/posts?isSpecial=true`}><span><MenuItem>Posts</MenuItem></span></Link>
                    : <Link to={`${match.url}/posts?isExclusive=true`}><span><MenuItem>Posts</MenuItem></span></Link>
                }
              </MenuList>
            </div>
            <div className="col-md-10 card-left">
              <PageHighlightRouter match={match} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

PageHighlight.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      pageId:          PropTypes.string.isRequired,
      pageHighlightId: PropTypes.string.isRequired,
    }),
    url: PropTypes.string.isRequired,
  }).isRequired,

  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,

  pageInView: PropTypes.shape({
    id:   PropTypes.number,
    name: PropTypes.string,
  }),

  dispatchEditPage: PropTypes.func.isRequired,
};

PageHighlight.defaultProps = {
  pageInView: { id: null, name: null },
};

const mapStateToProps = (state) => ({
  pageInView: state.admin.page.pageInView,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchEditPage: (p) => dispatch(editPage(p)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageHighlight);
